import { render } from "./CustomersView.vue?vue&type=template&id=c93b492a"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__